import React, { useState, useEffect } from "react";
import { bulkMoveFamilyMembers } from "../../service/FamilyMemberApi";
import { fetchFamilyById } from "../../service/FamilyApi";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { Loading } from "../../components/shared";
import { useParams, } from "react-router-dom";
import { useCheckAccess, maskAadhar } from "../../utils/Utilities";

function BulkMoveFamilyMembers() {
    useCheckAccess('FamilyAdmin');
    const [fromId, setFromId] = useState("");
    const [toId, setToId] = useState("");
    const [fromFamily, setFromFamily] = useState(null);
    const [toFamily, setToFamily] = useState(null);
    const [selected, setSelected] = useState(new Set());
    const { id } = useParams();

    const [loading, setLoading] = React.useState(false);
    const [loadingFrom, setLoadingFrom] = React.useState(false);
    const [loadingTo, setLoadingTo] = React.useState(false);

    useEffect(() => {
        if (id) {
            setFromId(id);
        }
    }, [id]);
    const loadFrom = async () => {
        setLoadingFrom(true);
        const data = await fetchFamilyById(fromId);
        setFromFamily(data.family);
        setSelected(new Set());
        setLoadingFrom(false);
    };

    const loadTo = async () => {
        setLoadingTo(true);
        const data = await fetchFamilyById(toId);
        setToFamily(data.family);
        setLoadingTo(false);
    };

    const toggleSelect = (aadhar) => {
        const s = new Set(selected);
        if (s.has(aadhar)) s.delete(aadhar);
        else s.add(aadhar);
        setSelected(s);
    };

    const handleMove = async () => {
        setLoading(true);
        if (!fromFamily || !toFamily || selected.size === 0) {
            alert("இரண்டு குடும்பங்களையும் மற்றும் குறைந்தது ஒரு உறுப்பினரையும் தேர்வு செய்யவும்.");
            return;
        }
        if (window.confirm(`${selected.size} உறுப்பினரை குடும்பம் ${toId}-க்கு நகர்க்க வேண்டுமா?`)) {
            const response = await bulkMoveFamilyMembers({
                memberAadhars: [...selected],
                toFamilyId: toId,
                fromId: fromId
            });
            if (response) {
                await loadFrom();
                await loadTo();

                setSelected(new Set());
                alert("நகர்வு வெற்றிகரமாக முடிந்தது!");

            }
            else {
                alert("குடும்ப உறுப்பினர்களை மாற்றுவதில் பிழை.!");
            }
        }
        setLoading(false);
    };
    if (loading) {
        return (
            <>
                <Navbar />
                <div className="general_parent">
                    <div className="general_container">
                        <div className="general_body">
                            <Breadcrumbs /><br />
                            <Loading />
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
    return (
        <div>
            <Navbar />
            <Helmet>
                <title>குடும்ப உறுப்பினர் புதுப்பிப்பு</title>
                <link rel="canonical" href={`/family/builk-move`} />
            </Helmet>

            <div className="general_parent">
                <div className="general_container">
                    <div className="general_body">
                        <Breadcrumbs /><br />
                        <h3>குடும்ப உறுப்பினர்களை நகர்த்துதல்</h3>
                        <br />
                        <div className="auth_element">
                            <label className="auth_label">தொடக்க குடும்ப எண்:</label>
                            <input value={fromId} onChange={(e) => setFromId(e.target.value)} />
                            <button onClick={loadFrom} disabled={loadingFrom}>தொடக்க குடும்பத்தை பெறு</button>
                        </div>
                        <br />
                        <div className="auth_element">
                            <label className="auth_label">இலக்கு குடும்ப எண்:</label>
                            <input value={toId} onChange={(e) => setToId(e.target.value)} />
                            <button onClick={loadTo} disabled={loadingTo}>இலக்கு குடும்பத்தை பெறு</button>
                        </div>
                        <br />
                        {fromFamily && (
                            <>
                                <div className="details-card">
                                    <h3>தொடக்க குடும்ப எண்: {fromFamily.id} </h3>
                                    <br />
                                    <div className="detail-item">
                                        <span className="detail-label"><strong>குடும்பத் தலைவர்:</strong></span>
                                        <span>
                                            {fromFamily.familyHeadFirstName || ""}
                                            {fromFamily.familyHeadLastName ? ` ${fromFamily.familyHeadLastName}` : ""}
                                        </span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label"><strong>குடும்பத் தலைவர் ஆதார் எண்:</strong></span>
                                        <span style={{ color: fromFamily.familyHeadAadhar?.startsWith("TMP") ? "red" : "inherit" }}>
                                            {maskAadhar(fromFamily.maskedFamilyHeadAadhar) || ""}
                                        </span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label"><strong>நிரந்தர அஞ்சல்:</strong></span>
                                        <span>{fromFamily.permanentAddressName_tamil || ""}{", "}{fromFamily.permanentAddressBlock_tamil || ""}{", "}{fromFamily.permanentAddressDistrict_tamil || ""}</span>
                                    </div>
                                    {fromFamily.tempAddressDistrict_tamil && (
                                        <div className="detail-item">
                                            <span className="detail-label"><strong>தற்காலிக அஞ்சல் :</strong></span>
                                            <span>
                                                {fromFamily.tempAddressName_tamil || ""}
                                                {fromFamily.tempAddressBlock_tamil ? ", " + fromFamily.tempAddressBlock_tamil : ""}
                                                {fromFamily.tempAddressDistrict_tamil ? ", " + fromFamily.tempAddressDistrict_tamil : ""}
                                            </span>
                                        </div>
                                    )}

                                    <ul>
                                        {fromFamily.familyMembers.map((m) => (
                                            <li key={m.aadhar}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        checked={selected.has(m.aadhar)}
                                                        onChange={() => toggleSelect(m.aadhar)}
                                                    />
                                                    {m.firstName} {m.lastName} | ஆதார்: {m.aadhar} | m: {m.mobile}
                                                </label>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </>
                        )}

                        {toFamily && (
                            <>
                                <br />
                                <div className="details-card">
                                    <h3>இலக்கு குடும்ப எண்: {toFamily.id} </h3>
                                    <br />
                                    <div className="detail-item">
                                        <span className="detail-label"><strong>குடும்பத் தலைவர்:</strong></span>
                                        <span>
                                            {toFamily.familyHeadFirstName || ""}
                                            {toFamily.familyHeadLastName ? ` ${toFamily.familyHeadLastName}` : ""}
                                        </span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label"><strong>குடும்பத் தலைவர் ஆதார் எண்:</strong></span>
                                        <span style={{ color: toFamily.familyHeadAadhar?.startsWith("TMP") ? "red" : "inherit" }}>
                                            {maskAadhar(toFamily.maskedFamilyHeadAadhar) || ""}
                                        </span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label"><strong>நிரந்தர அஞ்சல்:</strong></span>
                                        <span>{toFamily.permanentAddressName_tamil || ""}{", "}{toFamily.permanentAddressBlock_tamil || ""}{", "}{toFamily.permanentAddressDistrict_tamil || ""}</span>
                                    </div>
                                    {toFamily.tempAddressDistrict_tamil && (
                                        <div className="detail-item">
                                            <span className="detail-label"><strong>தற்காலிக அஞ்சல் :</strong></span>
                                            <span>
                                                {toFamily.tempAddressName_tamil || ""}
                                                {toFamily.tempAddressBlock_tamil ? ", " + toFamily.tempAddressBlock_tamil : ""}
                                                {toFamily.tempAddressDistrict_tamil ? ", " + toFamily.tempAddressDistrict_tamil : ""}
                                            </span>
                                        </div>
                                    )}

                                    <ul>
                                        {toFamily.familyMembers.map((m) => (
                                            <li key={m.aadhar}>
                                                {m.firstName} {m.lastName}  | ஆதார்: {m.aadhar} | m: {m.mobile}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </>
                        )}
                        <br />
                        <button onClick={handleMove} disabled={loading}>தேர்ந்த உறுப்பினர்களை நகர்த்து →</button>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default BulkMoveFamilyMembers;
